module.exports = __webpack_public_path__ + "static/media/responsive-no-tier-person.b0736563.svg";